import { soyshareApi } from '../../../../../services/api'

const api = soyshareApi.injectEndpoints({
  endpoints: (build) => ({
    getLocationTypes: build.query({
      query: () => ({ url: '/location-type' }),
      providesTags: ['location-types']
    }),

    getLocationTypesDropdown: build.query({
      query: (params) => ({ url: '/location-type/dropdown/list', params }),
      providesTags: ['location-types-dropdown']
    })
  })
})

export const { useGetLocationTypesQuery, useGetLocationTypesDropdownQuery } = api
